import { render, staticRenderFns } from "./TextSetting.vue?vue&type=template&id=72858ef8&scoped=true"
import script from "./TextSetting.vue?vue&type=script&lang=js"
export * from "./TextSetting.vue?vue&type=script&lang=js"
import style0 from "./TextSetting.vue?vue&type=style&index=0&id=72858ef8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72858ef8",
  null
  
)

export default component.exports